export const PRIMARY_RED = '#f64c4c'
